import ReservationBusinessTimes        from "./ReservationBusinessTimes";
import ReservationSpecialBusinessTimes from "./ReservationSpecialBusinessTimes";
import ReservationTimeTypeClass        from "./ReservationTimeTypeClass";

export default class ReservationSetting {
  constructor(
    private readonly _timeType: ReservationTimeTypeClass = new ReservationTimeTypeClass(),
    private readonly _businessTimes: ReservationBusinessTimes = new ReservationBusinessTimes(),
    private readonly _specialBusinessTimes: ReservationSpecialBusinessTimes = new ReservationSpecialBusinessTimes()
  ) {
  }

  get timeType() {
    return this._timeType;
  }

  get businessTimes() {
    return this._businessTimes;
  }

  get specialBusinessTimes() {
    return this._specialBusinessTimes;
  }
}
